// extracted by mini-css-extract-plugin
export default {"widget":"widget_widget__g-rc0","head":"widget_head__A9zD4"};